import { render, staticRenderFns } from "./DetailLegacy.vue?vue&type=template&id=125dc118&scoped=true&"
import script from "./DetailLegacy.vue?vue&type=script&lang=js&"
export * from "./DetailLegacy.vue?vue&type=script&lang=js&"
import style0 from "./DetailLegacy.vue?vue&type=style&index=0&id=125dc118&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125dc118",
  null
  
)

export default component.exports